import React from 'react';
import { T, fontBody } from '../tokens';

export default function Field({ label, children }) {
  return (
    <div>
      <div style={{ fontFamily: fontBody, fontSize: 12, fontWeight: 600, color: T.slate, marginBottom: 6 }}>{label}</div>
      {children}
    </div>
  );
}
